import React, { FC } from "react";
import cn from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { LogoutButton } from "src/page-components/auth/Logout/LogoutButton";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { ISidebarItem } from "./types";
import { SidebarItem } from "./SidebarItem";

const SWIPER_SLIDE_CLASSNAME =
  "flex-shrink max-w-max gl:max-w-full whitespace-nowrap";

interface Props {
  items: ISidebarItem[];
  className?: string;
  showLogoutButton?: boolean;
  sidebarItemClassName?: string;
  screenBreakpoint?: number;
}

export const NavigationSidebar: FC<Props> = ({
  items,
  className,
  showLogoutButton = true,
  sidebarItemClassName,
  screenBreakpoint,
}) => (
  <div className={cn("overflow-hidden", className)}>
    <Swiper
      className="w-full mb-2 xl:mb-0 !overflow-visible"
      spaceBetween={8}
      slidesPerView="auto"
      direction="horizontal"
      breakpoints={{
        [screenBreakpoint || SCREEN_BREAKPOINTS.XL]: {
          direction: "vertical",
          spaceBetween: 12,
          allowTouchMove: false,
        },
      }}
    >
      {items.map((item) => (
        <SwiperSlide key={item.id} className={SWIPER_SLIDE_CLASSNAME}>
          <SidebarItem item={item} tabClassName={sidebarItemClassName} />
        </SwiperSlide>
      ))}

      {showLogoutButton && (
        <SwiperSlide className={SWIPER_SLIDE_CLASSNAME}>
          <LogoutButton
            className={cn(
              "font-medium w-full rounded-20 border border-black-base/20 !scale-100 !brightness-100 hover:bg-red-lighter hover:border-inherit hover:text-white-base",
              sidebarItemClassName
            )}
          />
        </SwiperSlide>
      )}
    </Swiper>
  </div>
);
